import TagGrid from './TagGrid';

export default TagGrid;
